import React from "react"
import {UxCTA as CTA} from "@next/ux-cta"
import MiniShoppingBagItems from "../../../MiniShoppingBagItems"
import MiniShoppingBagCheckout from "../../../MiniShoppingBagCheckout"
import {
    ActionWrapper,
    CartItemsContainer,
    CTAContainer,
    EmptyBagWrapper,
    ItemCountWrapper,
    MiniShoppingBagContainer,
    MiniShoppingBagPriceWrapper,
    TotalText,
    EmptyBagTextWrapper,
    TotalValue,
} from "./component"
import {
    HEADER_NAV_BAR_QUICK_LINKS,
    HEADER_NAV_BAR_SHOPPING_BAG_CHECKOUT,
    HEADER_NAV_BAR_SHOPPING_BAG_VIEW_BAG,
    HEADER_NAV_BAR_QUICK_LINKS_SHOPPING_BAG,
} from "../../../../config/constants"
import {removeDeptFromSessionStorage} from "../../../../utils/removeDeptFromSessionStorage"
import {MiniShoppingBagProps} from "../.."
import {IsEmpty} from "../../../../models/shoppingbag"

export type ClubMiniShoppingBagProps = Omit<MiniShoppingBagProps, "templating"> & {
    bagContainerRef: React.MutableRefObject<HTMLDivElement | null>
    bagItemsRef: React.MutableRefObject<HTMLDivElement | null>
}

export const ClubMiniShoppingBag = ({
    text: {singleItemInBag, multipleItemsInBag, emptyBagText, totalText, viewAndEditBag},
    itemCount,
    bag,
    shoppingBagUrl,
    bagContainerRef,
    bagItemsRef,
}: ClubMiniShoppingBagProps) => {
    const showEmpty = IsEmpty(bag)
    const getItemCountText = () => {
        const template = itemCount === 1 ? singleItemInBag : multipleItemsInBag
        return template.replace("{count}", itemCount.toString())
    }
    return (
        <MiniShoppingBagContainer data-testid="header-mini-shopping-bag" ref={bagContainerRef}>
            <ItemCountWrapper data-testid="header-mini-shopping-bag-item-count">{getItemCountText()}</ItemCountWrapper>

            {showEmpty ? (
                <>
                    <EmptyBagWrapper>
                        <EmptyBagTextWrapper data-testid="header-mini-shopping-bag-empty">
                            {emptyBagText}
                        </EmptyBagTextWrapper>
                    </EmptyBagWrapper>
                    <MiniShoppingBagPriceWrapper>
                        <TotalText>{totalText}</TotalText>
                        <TotalValue>{bag.FinalOrderValueFormatted}</TotalValue>
                    </MiniShoppingBagPriceWrapper>
                </>
            ) : (
                <CartItemsContainer data-testid="header-mini-shopping-bag-list" ref={bagItemsRef}>
                    <MiniShoppingBagItems />
                </CartItemsContainer>
            )}

            <ActionWrapper>
                <CTAContainer data-testid="mini-bag-cta-container">
                    <CTA
                        text={viewAndEditBag}
                        url={shoppingBagUrl}
                        color="secondary"
                        state="enabled"
                        variant="outlined"
                        size="medium"
                        dataGaV1={HEADER_NAV_BAR_QUICK_LINKS}
                        dataGaV2={HEADER_NAV_BAR_QUICK_LINKS_SHOPPING_BAG}
                        dataGaV3={HEADER_NAV_BAR_SHOPPING_BAG_VIEW_BAG}
                        onClick={removeDeptFromSessionStorage}
                    />
                </CTAContainer>
                <MiniShoppingBagCheckout
                    dataGaV1={HEADER_NAV_BAR_QUICK_LINKS}
                    dataGaV2={HEADER_NAV_BAR_QUICK_LINKS_SHOPPING_BAG}
                    dataGaV3={HEADER_NAV_BAR_SHOPPING_BAG_CHECKOUT}
                />
            </ActionWrapper>
        </MiniShoppingBagContainer>
    )
}

export default ClubMiniShoppingBag
